import * as React from "react"
import { HeaderWithDescription } from "../common/HeaderWithDescription";
import CTA, { CTATheme } from "../common/CallToAction";
import AppLoader from "../utils/AppLoader";

interface IProps {
    closeModal: () => void,
    handleCompleteClick: () => void
}

const bodyContStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 30
}

const CompleteConsultConfirmation = (props: IProps) => {
    const [loading, showLoader] = React.useState(false);

    const handleCompleteAction = () => {
        showLoader(true);
        props.handleCompleteClick()
    }

    return (
        <div>
            <HeaderWithDescription text={"Complete Note?"} description={"Please review the note you have written. You will not be able to edit the note once you complete it."} />
            <div className={"body-container"} style={bodyContStyle}>
                {
                    loading ?
                        <AppLoader /> :
                        <>
                            <span onClick={() => props.closeModal()} style={{ color: "#ff316d", marginRight: 20, cursor: "pointer" }}>Cancel</span>
                            <CTA innerText={"Complete"} theme={CTATheme.PRIMARY} onClick={handleCompleteAction} />
                        </>
                }
            </div>
        </div>
    )
}

export default CompleteConsultConfirmation